module.exports = {
  Scene3D: {
    PluginName: "Objeto 3D",
    Empty: "No hay objeto 3D",
    InteractOn: "Girar",
    InteractOff: "✓ Giro activado",
    InteractOnHint: "Actívalo para girar y explotar el objeto",
    InteractOffHint: "Desactívalo para mover la caja",
  },
};
